// removed by extract-text-webpack-plugin
module.exports = {"commentLabel":"_3fjYhzyWGfYZEt_Wsza4Tk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuspendWireTransferForm/styles.scss
// module id = 3224
// module chunks = 0